<app-table 	[displayedColumns]="displayedColumns" 
			[columns]="columns" 
			[pageSize]="25" 
			url="/notifications"
			[title]="'notifications'|translate"
			sortColumn="created_at"
			sortDirection="desc"
            hideAddButton="true"
            hideSearch="true">
</app-table>